// const baseURL = "https://crm.funstay.in/crmbackend"; 
//const baseURL = "http://localhost:5000"; 
//const baseURL = "http://69.62.77.214:9000"; 

// const webhookUrl = "https://crm.funstay.in"; 
//const webhookUrl = "http://localhost:4000";


const adminMail = "admin"
const headofSalesMail = "saleshead@funstay.in"
const baseURL = "https://crm.funstay.in:5000";
// const baseURL = "http://69.62.77.214:9000";
 const webhookUrl = "https://crm.funstay.in:4000";
// Export them as named exports
export { baseURL, webhookUrl,adminMail,headofSalesMail };